<script>
  import { closeModal } from '$lib/features/app/modals';
  import Button from './Button.svelte';
  import Modal from './Modal.svelte';

  let {
    title = 'Är du säker?',
    text = 'Är du säker på att du vill göra detta?',
    list = [],
    cancelLabel = 'Avbryt',
    confirmLabel = 'Fortsätt',

    close = closeModal,
    /** Set to true when rendered via `showOverlayModal` so Esc owns this. */
    isOverlay = false,
    onConfirm = () => {},
    onDecline = undefined,
  } = $props();

  // Defaulted here rather than in the destructure so it can reference `close`.
  const decline = $derived(onDecline ?? close);

  let isLoading = $state(false);

  async function handleConfirmation() {
    isLoading = true;
    await onConfirm();
    isLoading = false;
    close();
  }
</script>

<Modal {title} size="sm" handleClose={isOverlay ? decline : null} {isOverlay}>
  <div class="w-full">
    <div class="text-center text-gray-3">{text}</div>

    {#if Array.isArray(list) && list.length}
      <div class="mb-6 mt-3 flex flex-col p-2">
        {#each list as item}
          <div class="border-b py-3 first:pt-0 last:border-none last:pb-0">
            {item}
          </div>
        {/each}
      </div>
    {/if}

    <div class="mt-4 flex justify-between gap-4">
      <div class="flex-1">
        <Button fullWidth onclick={decline} variant="secondary">
          {cancelLabel}
        </Button>
      </div>
      <div class="flex-1">
        <Button
          fullWidth
          onclick={handleConfirmation}
          variant="primary"
          loading={isLoading}
          autofocus={true}
        >
          {confirmLabel}
        </Button>
      </div>
    </div>
  </div>
</Modal>
